{
  "INBOX_MGMT": {
    "HEADER": "Inkorgar",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Anslut igen",
      "FACEBOOK": "Anslutningen till Facebook har gått ut eller återkallats. Meddelanden till sidan kommer inte fram till den här inkorgen, och svar kan misslyckas. En person som hanterar Facebook-sidan måste klicka på Anslut igen och logga in på Facebook.",
      "INSTAGRAM": "Anslutningen till Instagram har gått ut eller återkallats. Meddelanden till kontot kommer inte fram till den här inkorgen, och svar kan misslyckas. Klicka på Anslut igen och logga in på samma Instagram-konto. Ett annat konto skapar en ny inkorg.",
      "GOOGLE": "Anslutningen till Google har gått ut eller återkallats. Nya e-postmeddelanden kommer inte fram till den här inkorgen, och svar kan misslyckas. Klicka på Anslut igen och logga in på Google som {email}.",
      "MICROSOFT": "Anslutningen till Microsoft har gått ut eller återkallats. Nya e-postmeddelanden kommer inte fram till den här inkorgen, och svar kan misslyckas. Klicka på Anslut igen och logga in på Microsoft som {email}.",
      "ALLEGRO": "Anslutningen till Allegro har gått ut eller återkallats. Meddelanden från köpare kommer inte fram till den här inkorgen, och svar kan misslyckas. Klicka på Anslut igen och logga in på Allegro som säljaren {seller}. Ett annat säljarkonto skapar en ny inkorg.",
      "IMAP_LOGIN": "E-postservern avvisar IMAP-inloggningen {login}. Nya e-postmeddelanden når inte den här inkorgen. Kontrollera IMAP-inloggningen och lösenordet på fliken {tab} och spara dem. Vi fortsätter att försöka logga in, och inkorgen återhämtar sig så snart inloggningen fungerar.",
      "WHATSAPP": "Anslutningen till WhatsApp har gått ut eller återkallats. Bilagor från kunder når inte den här inkorgen, och svar kan misslyckas. Klicka på Anslut igen, logga in på Facebook och välj numret {phone} igen."
    },
    "LIST": {
      "404": "Det finns inga inkorgar kopplade till detta konto.",
      "RECONNECT_REQUIRED": "Måste anslutas igen"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Välj kanal",
        "BODY": "Välj den leverantör du vill integrera med chatten."
      },
      "INBOX": {
        "TITLE": "Skapa inkorg",
        "BODY": "Autentisera ditt konto och skapa en inkorg."
      },
      "AGENT": {
        "TITLE": "Lägg till agenter",
        "BODY": "Lägg till agenter till den skapade inkorgen."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Ni är redo att köra!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Inkorgsnamn",
        "PLACEHOLDER": "Ange ditt inkorgsnamn (t. ex. Acme Inc)",
        "ERROR": "Please enter a valid inbox name"
      },
      "WEBSITE_NAME": {
        "LABEL": "Website Name",
        "PLACEHOLDER": "Ange namnet på din webbplats (t.ex. Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Internt namn",
        "PLACEHOLDER": "Namnge inkorgen som den visas i den här instrumentpanelen",
        "ERROR": "Ange ett unikt internt namn"
      },
      "FB": {
        "HELP": "PS: Genom att logga in får vi bara tillgång till din sidas meddelanden. Dina privata meddelanden kan vi aldrig komma åt.",
        "CHOOSE_PAGE": "Välj sida",
        "CHOOSE_PLACEHOLDER": "Välj en sida från listan",
        "INBOX_NAME": "Inkorgsnamn",
        "ADD_NAME": "Lägg till ett namn för din inkorg",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Välj ett värde",
        "CREATE_INBOX": "Skapa inkorg"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Fortsätt med Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Anslut din Instagram-profil",
        "HELP": "För att lägga till din Instagram-profil som en kanal måste du autentisera din Instagram-profil genom att klicka på 'Fortsätt med Instagram' ",
        "ERROR_MESSAGE": "Det uppstod ett fel vid anslutning till Instagram, försök igen",
        "ERROR_AUTH": "Det uppstod ett fel vid anslutning till Instagram, försök igen",
        "NEW_INBOX_SUGGESTION": "Det här Instagram-kontot var tidigare kopplat till en annan inkorg och har nu flyttats hit. Alla nya meddelanden visas här. Den gamla inkorgen kommer inte längre kunna skicka eller ta emot meddelanden för det här kontot.",
        "DUPLICATE_INBOX_BANNER": "Det här Instagram-kontot har flyttats till den nya Instagram-kanalens inkorg. Du kommer inte längre kunna skicka/ta emot Instagram-meddelanden från den här inkorgen."
      },
      "TWITTER": {
        "HELP": "För att lägga till din Twitter-profil som en kanal måste du autentisera din Twitter-profil genom att klicka på \"Logga in med Twitter\" ",
        "ERROR_MESSAGE": "There was an error connecting to Twitter, please try again",
        "TWEETS": {
          "ENABLE": "Create conversations from mentioned Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Webbplatskanal",
        "DESC": "Skapa en kanal för din webbplats och börja stödja dina kunder via vår hemsida widget.",
        "LOADING_MESSAGE": "Skapar supportkanal för webbplats",
        "CHANNEL_AVATAR": {
          "LABEL": "Kanalavatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Ange en giltig URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Webbplatsens domän",
          "PLACEHOLDER": "Ange din webbplatsdomän (t.ex. acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Välkomstrubrik",
          "PLACEHOLDER": "Hej där!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Välkomsttagline",
          "PLACEHOLDER": "Vi gör det enkelt att ta kontakt med oss. Fråga oss något, eller dela din feedback."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Kanalhälsningsmeddelande",
          "PLACEHOLDER": "Acme Inc svarar vanligtvis inom några timmar."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Aktivera kanalhälsning",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Aktiverad",
          "DISABLED": "Inaktiverad"
        },
        "REPLY_TIME": {
          "TITLE": "Ställ in svarstid",
          "IN_A_FEW_MINUTES": "Inom några minuter",
          "IN_A_FEW_HOURS": "Inom några timmar",
          "IN_A_DAY": "Inom en dag",
          "HELP_TEXT": "Den här svarstiden kommer att visas på livechattswidgeten"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widgetfärg",
          "PLACEHOLDER": "Uppdatera den widgetfärg som används i widget"
        },
        "SUBMIT_BUTTON": "Skapa inkorg",
        "API": {
          "ERROR_MESSAGE": "We were not able to create a website channel, please try again"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Channel",
        "DESC": "Integrate Twilio and start supporting your customers via SMS or WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Kontots SID",
          "PLACEHOLDER": "Ange SID för ditt Twilio-konto",
          "ERROR": "Detta fält är obligatoriskt"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Detta fält är obligatoriskt"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Detta fält är obligatoriskt"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Please enter your Twilio Messaging Service SID",
          "ERROR": "Detta fält är obligatoriskt",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanaltyp",
          "ERROR": "Var god välj din kanaltyp"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth-token",
          "PLACEHOLDER": "Ange din Auth-token för Twilio",
          "ERROR": "Detta fält är obligatoriskt"
        },
        "CHANNEL_NAME": {
          "LABEL": "Inkorgsnamn",
          "PLACEHOLDER": "Please enter a inbox name",
          "ERROR": "Detta fält är obligatoriskt"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonnummer",
          "PLACEHOLDER": "Ange telefonnummer från vilket meddelande som ska skickas.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Callback-URL",
          "SUBTITLE": "Du måste konfigurera meddelande-callback-URL i Twilio med den URL som nämns här."
        },
        "SUBMIT_BUTTON": "Skapa Twiliokanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunde inte autentisera Twilio-uppgifterna, försök igen"
        }
      },
      "SMS": {
        "TITLE": "SMS Channel",
        "DESC": "Start supporting your customers via SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the SMS channel"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "Please enter your Bandwidth Account ID",
            "ERROR": "Detta fält är obligatoriskt"
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Detta fält är obligatoriskt"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Detta fält är obligatoriskt"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "Please enter your Bandwidth Application ID",
            "ERROR": "Detta fält är obligatoriskt"
          },
          "INBOX_NAME": {
            "LABEL": "Inkorgsnamn",
            "PLACEHOLDER": "Please enter a inbox name",
            "ERROR": "Detta fält är obligatoriskt"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Ange telefonnummer från vilket meddelande som ska skickas.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to authenticate Bandwidth credentials, please try again"
          },
          "API_CALLBACK": {
            "TITLE": "Callback-URL",
            "SUBTITLE": "You have to configure the message callback URL in Bandwidth with the URL mentioned here."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Inkorgens namn",
            "PLACEHOLDER": "Ange ett namn för inkorgen",
            "ERROR": "Det här fältet är obligatoriskt"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Ange telefonnumret som meddelanden ska skickas från.",
            "ERROR": "Ange ett giltigt telefonnummer som börjar med tecknet `+`."
          },
          "SUBMIT_BUTTON": "Skapa SMS Brana-kanal",
          "API": {
            "ERROR_MESSAGE": "Vi kunde inte skapa SMS Brana-kanalen"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Inkorgens namn",
            "PLACEHOLDER": "Ange ett namn för inkorgen",
            "ERROR": "Det här fältet är obligatoriskt"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Ange telefonnumret som meddelanden ska skickas från.",
            "ERROR": "Ange ett giltigt telefonnummer som börjar med tecknet `+`."
          },
          "SUBMIT_BUTTON": "Skapa DIDWW-kanal",
          "API": {
            "ERROR_MESSAGE": "Vi kunde inte skapa DIDWW-kanalen"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Snabb konfiguration med Meta",
          "DESC": "Du omdirigeras till Meta för att logga in på ditt WhatsApp Business-konto. Administratörsbehörighet gör konfigurationen smidig och enkel.",
          "BENEFITS": {
            "EASY_SETUP": "Ingen manuell konfiguration krävs",
            "SECURE_AUTH": "Säker autentisering baserad på OAuth",
            "AUTO_CONFIG": "Automatisk konfiguration av webhook och telefonnummer"
          },
          "SUBMIT_BUTTON": "Anslut med WhatsApp Business",
          "AUTH_PROCESSING": "Autentiserar med Meta",
          "WAITING_FOR_BUSINESS_INFO": "Slutför affärskontots konfiguration i Meta-fönstret...",
          "PROCESSING": "Konfigurerar ditt WhatsApp Business-konto",
          "CANCELLED": "WhatsApp-registreringen avbröts",
          "WAITING_FOR_AUTH": "Väntar på autentisering...",
          "INVALID_BUSINESS_DATA": "Ogiltig företagsdata mottogs från Facebook. Försök igen.",
          "SIGNUP_ERROR": "Ett registreringsfel uppstod",
          "SDK_LOAD_ERROR": "Det gick inte att läsa in Facebook SDK. Försök igen.",
          "AUTH_NOT_COMPLETED": "Autentiseringen slutfördes inte. Starta om processen.",
          "SUCCESS_FALLBACK": "WhatsApp Business-kontot har konfigurerats",
          "RECONNECTED": "WhatsApp-kanalen har anslutits igen"
        },
        "API": {
          "ERROR_MESSAGE": "Vi kunde inte spara WhatsApp-kanalen"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API-kanal",
        "DESC": "Integrera med API-kanalen och börja supporta dina kunder.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnamn",
          "PLACEHOLDER": "Ange ett kanalnamn",
          "ERROR": "Detta fält är obligatoriskt"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Skapa API-kanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunde inte spara API-kanalen"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce-kanal",
        "DESC": "Integrera med Salesforce-kanalen och börja supporta dina kunder.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnamn",
          "PLACEHOLDER": "Ange ett kanalnamn",
          "ERROR": "Det här fältet är obligatoriskt"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API-URL",
          "SUBTITLE": "Konfigurera bas-URL:en för din Salesforce-instans.",
          "PLACEHOLDER": "Salesforce API-URL"
        },
        "KEY_ID": {
          "LABEL": "Nyckel-ID",
          "SUBTITLE": "Nyckel-ID för din Salesforce-kanal.",
          "PLACEHOLDER": "NYCKEL-ID"
        },
        "SECRET": {
          "LABEL": "Hemlighet",
          "SUBTITLE": "Hemlighet för din Salesforce-kanal.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Skapa Salesforce-kanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunde inte spara Salesforce-kanalen"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook-URL",
          "SUBTITLE": "Du måste konfigurera webhook-URL:en i Salesforce med URL:en som anges här."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Använd den här bearer-token för autentisering när du konfigurerar webhooken i Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Åsidosätt avsändare för e-post",
          "SUBTITLE": "Om den anges används den här e-postadressen som avsändare för alla utgående e-postmeddelanden istället för konversationens ursprungliga e-post.",
          "PLACEHOLDER": "t.ex. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro-kanal",
        "DESC": "Anslut ett Allegro-säljarkonto och svara på dess meddelandecenter från kontaktcentret.",
        "CHANNEL_NAME": {
          "LABEL": "Inkorgsnamn",
          "SUBTITLE": "Namnet som agenter ser för den här inkorgen.",
          "PLACEHOLDER": "Ange ett inkorgsnamn",
          "ERROR": "Detta fält är obligatoriskt"
        },
        "SUBMIT_BUTTON": "Logga in med Allegro",
        "API": {
          "ERROR_MESSAGE": "Det uppstod ett fel vid anslutningen till Allegro, försök igen"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro-inloggning",
          "SUBTITLE": "Säljarkontot som den här inkorgen läser och svarar på meddelanden för."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland-kanal",
        "DESC": "Svara på ärendemeddelandena som köpare skickar till dig på Kaufland-marknadsplatsen.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnamn",
          "PLACEHOLDER": "Ange ett kanalnamn",
          "ERROR": "Detta fält är obligatoriskt"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Den 32 tecken långa Client Key från API-inställningssidan för ditt Kaufland-säljarkonto.",
          "PLACEHOLDER": "32 tecken lång nyckel",
          "ERROR": "Ange den 32 tecken långa Client Key"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Den 64 tecken långa Secret Key som hör till Client Key. Kaufland visar den en gång, och den skickas aldrig tillbaka till den här sidan.",
          "PLACEHOLDER": "64 tecken lång nyckel",
          "ERROR": "Ange den 64 tecken långa Secret Key"
        },
        "SUBMIT_BUTTON": "Skapa Kaufland-kanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunde inte spara Kaufland-kanalen"
        },
        "DISCONNECTED": {
          "TITLE": "Frånkopplad",
          "MESSAGE": "Kaufland avvisade dessa API-nycklar. Ange Client Key och Secret Key igen för att återansluta den här inkorgen."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-postkanal",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnamn",
          "PLACEHOLDER": "Ange ett kanalnamn",
          "ERROR": "Detta fält är obligatoriskt"
        },
        "EMAIL": {
          "LABEL": "E-post",
          "SUBTITLE": "E-post dit dina kunder skickar supportärenden",
          "PLACEHOLDER": "E-post"
        },
        "SUBMIT_BUTTON": "Skapa e-postkanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunde inte spara e-postkanalen"
        },
        "FINISH_MESSAGE": "Börja vidarebefordra dina e-postmeddelanden till följande e-postadress."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE kanal",
        "DESC": "Integrera med LINE-kanalen och börja stödja dina kunder.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalnamn",
          "PLACEHOLDER": "Ange ett kanalnamn",
          "ERROR": "Detta fält är obligatoriskt"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE kanal-ID",
          "PLACEHOLDER": "LINE kanal-ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE kanal hemlighet",
          "PLACEHOLDER": "LINE kanal hemlighet"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE kanal hemlighet",
          "PLACEHOLDER": "LINE kanal hemlighet"
        },
        "SUBMIT_BUTTON": "Skapa API-kanal",
        "API": {
          "ERROR_MESSAGE": "Vi kunde inte spara API-kanalen"
        },
        "API_CALLBACK": {
          "TITLE": "Callback-URL",
          "SUBTITLE": "Du måste konfigurera webhook URL i LINE-programmet med den URL som nämns här."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram kanal",
        "DESC": "Integrera med Telegram kanal och börja stödja dina kunder.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Konfigurera bot token du har fått från Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Create Telegram Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the telegram channel"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefonsamtal",
        "DESC": "Ställ in vilka telefonsamtal som ska visas under den här inkorgen.",
        "NAME": {
          "LABEL": "Inkorgens namn",
          "SUBTITLE": "Välj ett lättigenkännligt namn."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonnummer",
          "SUBTITLE": "Ange telefonnummer som tillhör den här inkorgen, du kan lägga till fler nummer senare.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Skapa inkorg för telefonsamtal",
        "API": {
          "ERROR_MESSAGE": "Vi kunde inte skapa inkorgen"
        }
      },
      "AUTH": {
        "TITLE": "Välj en kanal",
        "DESC": "Chatten stöder livechatt-widgetar, Facebook Messenger, WhatsApp, e-post osv. som kanaler. Om du vill bygga en anpassad kanal kan du skapa den med API-kanalen. Välj en av kanalerna nedan för att komma igång."
      },
      "AGENTS": {
        "TITLE": "Agenter",
        "DESC": "Här kan du lägga till agenter för att hantera din nyskapade inkorg. Endast dessa utvalda agenter har tillgång till din inkorg. Agenter som inte är en del av denna inkorg kommer inte att kunna se eller svara på meddelanden i denna inkorg när de loggar in. <br> <b>PS:</b> Som administratör om du behöver åtkomst till alla inkorgar, du bör lägga till dig själv som agent till alla inkorgar som du skapar.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Välj agenter för inkorgen"
      },
      "DETAILS": {
        "TITLE": "Inkorgsdetaljer",
        "DESC": "Från rullgardinsmenyn nedan, välj den Facebook-sida du vill ansluta till chatten. Du kan också ge ett anpassat namn till din inkorg för bättre identifiering."
      },
      "FINISH": {
        "TITLE": "Där satt den!",
        "DESC": "Du har framgångsrikt integrerat din Facebook-sida med chatten. Nästa gång en kund meddelar din sida kommer konversationen automatiskt att visas på din inkorg.<br>Vi ger dig också en widget skript som du enkelt kan lägga till din webbplats. När detta är live på din webbplats, kunder kan meddela dig direkt från din webbplats utan hjälp av något externt verktyg och konversationen kommer att visas här i chatten.<br>Cool, va? Tja, vi försöker säkert att vara :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Autentiserar dig med Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Något gick fel, vänligen ladda om sidan...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Vi kunde inte skapa inkorgen. Försök igen.",
      "CREATING_CHANNEL": "Skapar din inkorg...",
      "TITLE": "Konfigurera Inkorgsdetaljer",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Lägg till agenter",
      "ADD_AGENTS": "Lägger till agenter i din inkorg..."
    },
    "FINISH": {
      "TITLE": "Din inkorg är redo!",
      "MESSAGE": "Du kan nu interagera med dina kunder genom din nya kanal. Supporta glatt",
      "BUTTON_TEXT": "Ta mig dit",
      "MORE_SETTINGS": "Fler inställningar",
      "WEBSITE_SUCCESS": "Du har skapat en webbplatskanal. Kopiera koden som visas nedan och klistra in den på din webbplats. Nästa gång en kund använder livechatten visas konversationen automatiskt i din inkorg."
    },
    "REAUTH": "Återauktorisera",
    "VIEW": "Visa",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Inkorgen har uppdaterats",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatisk tilldelning har uppdaterats",
        "ERROR_MESSAGE": "We couldn't update inbox settings. Please try again later."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Aktiverad",
        "DISABLED": "Inaktiverad"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Aktiverad",
        "DISABLED": "Inaktiverad"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Aktiverad",
        "DISABLED": "Inaktiverad"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "från",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Spara"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Aktiverad",
        "DISABLED": "Inaktiverad"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Aktiverad",
        "DISABLED": "Inaktiverad"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Ingen"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Aktiverad",
        "DISABLED": "Inaktiverad"
      },
      "ENABLE_HMAC": {
        "LABEL": "Aktivera"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Aktiverad",
        "DISABLED": "Inaktiverad"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Aktiverad",
        "DISABLED": "Inaktiverad"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Aktivera synkronisering av inkommande e-post"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Aktivera anpassad e-postdomän (betaltjänst)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Aktivera hantering av Facebook-kommentarer"
      },
      "SIGNATURE": {
        "TITLE": "HTML-signatur",
        "SUB_TEXT": "Den här signaturen läggs till i foten på varje meddelande som skickas från den här inkorgen.",
        "HTML_CONTENT": "HTML-kod",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} ersätts med agentens namn.\n{'{{'}email{'}}'} ersätts med e-postadressen till agenten som skickade e-postmeddelandet.\n{'{{'}position{'}}'} ersätts med agentens befattning.\n{'{{'}custom_line{'}}'} ersätts med agentens anpassade rad.\n{'{{'}email_signature_picture{'}}'} ersätts med URL:en till agentens signaturbild för e-post (inte en bildtagg) — använd den som bildkälla (src-attributet för en img-tagg).",
        "PREVIEW": "Förhandsgranskning"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Signaturer per land",
        "SUB_TEXT": "Ett svar får signaturen för köparens land.",
        "HELP": "Ett svar signeras efter konversationens land: efter Kauflands butik, efter marknadsplatsen för Allegro-ordern, annars efter det språk köparen skriver på. Om landet är okänt eller saknar signatur här används HTML-signaturen ovan. Marknadsplatserna förbjuder länkar till din webbplats och kontaktuppgifter, så håll dig till en hälsning och {'{{'}name{'}}'}.",
        "EMPTY": "Du har inga landssignaturer ännu, så svar använder HTML-signaturen ovan.",
        "COUNTRY": "Välj ett land",
        "ADD": "Lägg till signatur för land",
        "REMOVE": "Ta bort"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Uppringningsprefix för telefonnummer",
        "PLACEHOLDER": "Ange ett prefix för korrekt samtalsdirigering (t.ex. *99)",
        "HELP_TEXT": "Det här prefixet läggs automatiskt till framför kontakternas telefonnummer vid uppringning från den här inkorgen."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Text på knappen ”Lös senare”",
        "PLACEHOLDER": "t.ex. Vi löser detta ämne via e-post. Jag vill fråga om något annat nu.",
        "HELP_TEXT": "Text på widgetknappen som låter besökaren lämna det aktuella ämnet och fråga om något annat. Lämna fältet tomt för att använda standardtexten på besökarens språk."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Snooza automatiskt missade samtal i X minuter",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Snooza automatiskt missade samtal under angivet antal minuter. Lämna tomt eller 0 för att inaktivera."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Lös ett missat samtal efter X misslyckade återuppringningar",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "När ett missat samtal har ringts upp igen X gånger utan att kunden svarat löses det automatiskt och en privat anteckning läggs till. Lämna tomt eller 0 för att inaktivera."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Frågeförslag",
        "SUB_TEXT": "Konfigurera fördefinierade frågor som kunder kan använda för att interagera med dina agenter.",
        "QUESTIONS_LABEL": "Frågor",
        "ADD_QUESTION": "Lägg till fråga",
        "REMOVE": "Ta bort",
        "QUESTION_TEXT": "Text som visas i pratbubblan.",
        "QUESTION_TEXT_PLACEHOLDER": "Obligatoriskt",
        "QUESTION_PAYLOAD": "Text som skickas vid klick.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Valfritt",
        "NO_BOT_MESSAGE": "Anslut en bot för att generera fler AI-förslag.",
        "BOT_CONNECTED_MESSAGE": "AI-frågeförslag från boten kan aktiveras i dess",
        "BOT_SETTINGS_LINK": "inställningar"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternativa e-postadresser",
        "SUB_TEXT": "Ytterligare adresser som denna inkorg ska behandla som sina egna när vidarebefordrad e-post tas emot.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Lägg till",
        "REMOVE": "Ta bort",
        "EMPTY": "Inga alternativa e-postadresser konfigurerade.",
        "HELP_TEXT": "När ett e-postmeddelande kommer in med en av dessa adresser som mottagare skickas svar med samma adress som avsändare. Se till att din utgående SMTP-server tillåter sändning från dessa adresser.",
        "SIGNATURE_LABEL": "Signatur",
        "PRIMARY_SIGNATURE": "Primär (standard)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Ytterligare signaturer",
        "SUB_TEXT": "Definiera ytterligare signaturer här och tilldela dem sedan till de alternativa e-postadresserna nedan.",
        "OPTION": "Signatur {number}",
        "ADD": "Lägg till signatur",
        "REMOVE": "Ta bort",
        "HELP_TEXT": "När ett svar skickas från en alternativ e-postadress används den tilldelade signaturen i stället för inkorgens signatur. Alternativa e-postadresser som lämnas på ”Primär (standard)” använder inkorgens signatur."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Radera",
      "AVATAR_DELETE_BUTTON_TEXT": "Ta bort Avatar",
      "DELETE_REQUESTED_TOOLTIP": "Den här inkorgen är markerad för radering",
      "RESTORE_BUTTON_TEXT": "Återställ",
      "CONFIRM": {
        "TITLE": "Bekräfta borttagning",
        "MESSAGE": "Är du säker på att ta bort ",
        "PLACE_HOLDER": "Vänligen skriv {inboxName} för att bekräfta",
        "YES": "Ja, ta bort ",
        "NO": "Nej, behåll "
      },
      "API": {
        "SUCCESS_MESSAGE": "Inkorgen har tagits bort",
        "MARKED_FOR_DELETION_MESSAGE": "Inkorgen har markerats för radering",
        "RESTORE_SUCCESS_MESSAGE": "Inkorgen har återställts",
        "ERROR_MESSAGE": "Kunde inte ta bort inkorgen. Försök igen senare.",
        "RESTORE_ERROR_MESSAGE": "Det gick inte att återställa inkorgen. Försök igen senare.",
        "AVATAR_SUCCESS_MESSAGE": "Inkorgavatar har tagits bort",
        "AVATAR_ERROR_MESSAGE": "Kunde inte ta bort inbox-avataren. Försök igen senare."
      }
    },
    "TABS": {
      "SETTINGS": "Inställningar",
      "COLLABORATORS": "Medarbetare",
      "AUTOMATIC_PRIORITY": "Automatisk prioritet",
      "AUTOMATIC_LABELING": "Automatisk märkning",
      "CONFIGURATION": "Konfiguration",
      "CAMPAIGN": "Kampanjer",
      "PRE_CHAT_FORM": "Förchattformulär",
      "BUSINESS_HOURS": "Öppettider",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot Configuration",
      "SLA": "SLA"
    },
    "SETTINGS": "Inställningar",
    "FEATURES": {
      "LABEL": "Funktioner",
      "DISPLAY_FILE_PICKER": "Visa filväljare på widgeten",
      "DISPLAY_EMOJI_PICKER": "Visa emoji-väljare på widgeten",
      "ALLOW_END_CONVERSATION": "Allow users to end conversation from the widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Visa knappen 'Starta en ny konversation' i widgetens sidhuvud",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Visa knappen 'Överför till en operatör' i widgetens sidhuvud",
      "AUTO_CLOSE_OLD": "Markera alla tidigare samtal från samma nummer som lösta när ett av dem löses",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Tilldela automatiskt missade samtal vid ett utgående samtal",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Tillåt agenter att skicka meddelanden när kontakten är offline och e-postkontinuitet inte är tillgänglig"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Skript för Messenger",
      "MESSENGER_SUB_HEAD": "Placera denna knapp i din body-tagg",
      "INBOX_AGENTS": "Agenter",
      "INBOX_TEAMS": "Team",
      "INBOX_COOPERATORS": "Medarbetare",
      "SELECT_PLACEHOLDER": "Välj",
      "AGENTS_OR_TEAMS_INFO": "Du kan tilldela antingen agenter eller team - inte båda samtidigt.",
      "INBOX_AGENTS_SUB_TEXT": "Lägg till eller ta bort agenter från denna inkorg",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "Uppdatera",
      "ENABLE_EMAIL_COLLECT_BOX": "Aktivera insamlingsbox för e-post",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Aktivera eller inaktivera insamlingsbox för e-post på ny konversation",
      "AUTO_ASSIGNMENT": "Aktivera automatisk tilldelning",
      "ENABLE_CSAT": "Aktivera CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Aktivera CSAT för varje meddelande",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Aktivera/inaktivera CSAT(kundnöjdhet) undersökning efter att ha löst ett samtal",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Aktivera/inaktivera CSAT-undersökning för varje meddelande som skickas av agenter",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversations will continue over email if the contact email address is available.",
      "RESPOND_FROM_EMAIL": "Svara från e-post",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "E-postmeddelanden till kunden — både svar och transkriberingar av konversationer — skickas med SMTP-inställningarna för den valda e-postinkorgen, från den valda adressen (inkorgens egen adress eller en av dess alias), och kundens svar kommer tillbaka via dess IMAP-adress.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Transkriberingar av konversationer skickas med SMTP-inställningarna för den valda e-postinkorgen, från den valda adressen (inkorgens egen adress eller en av dess alias), och svar kommer tillbaka via dess IMAP-adress.",
      "SHOW_WELCOME_SCREEN": "Visa välkomstskärm",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Visa välkomstskärmen när widgeten öppnas. Om detta är inaktiverat går widgeten direkt till konversationsvyn.",
      "AUTO_CLOSE_PENDING": "Lös AI-chattar automatiskt efter (timmar)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Lös AI-chattar automatiskt efter X timmars inaktivitet.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Enable or disable multiple conversations for the same contact in this inbox",
      "INBOX_UPDATE_TITLE": "Inkorgsinställningar",
      "INBOX_UPDATE_SUB_TEXT": "Uppdatera inställningarna för din inkorg",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Aktivera eller inaktivera automatisk tilldelning av nya konversationer till de agenter som lagts till den här inkorgen.",
      "HMAC_VERIFICATION": "Validering av användaridentitet",
      "HMAC_DESCRIPTION": "With this key you can generate a secret token that can be used to verify the identity of your users.",
      "HMAC_ROTATE": {
        "BUTTON": "Byt nyckel",
        "TITLE": "Byta hemlig nyckel?",
        "WARNING": "Den nuvarande nyckeln återkallas i samma ögonblick som du byter den.",
        "WARNING_DETAIL": "Det finns ingen övergångsperiod och nyckeln kan inte återställas.",
        "IMPACT": "Dina servrar måste signera användare med den nya nyckeln. Alla som fortfarande är signerade med den gamla klarar inte verifieringen. Om identitetsvalidering krävs kan de inte starta en konversation.",
        "CONFIRM": "Byt nyckel",
        "CANCEL": "Avbryt",
        "SUCCESS": "Den hemliga nyckeln har bytts",
        "ERROR": "Det gick inte att byta den hemliga nyckeln, försök igen"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Validering av användaridentitet",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests that cannot be verified will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Tvinga ny konversation vid varje laddning av widgeten",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Om aktiverad startar en ny konversation när widgeten öppnas i en ny flik eller ett nytt fönster.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Glöm kontakten när en ny konversation startas",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Om inaktiverad behåller en ny konversation som startas från widgeten den tidigare kontakten.",
      "INBOX_IDENTIFIER": "Identifierare för inkorgen",
      "INBOX_IDENTIFIER_SUB_TEXT": "Använd `inbox_identifier`-token som visas här för att autentisera dina API-klienter.",
      "FORWARD_EMAIL_TITLE": "Vidarebefordra till e-post",
      "FORWARD_EMAIL_SUB_TEXT": "Börja vidarebefordra dina e-postmeddelanden till följande e-postadress.",
      "EMAIL_FETCHING_ENABLED_TITLE": "E-postsynkronisering",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Aktivera automatisk synkronisering och nedladdning av inkommande e-post från den här inkorgen",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Anpassad e-postdomän",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Aktivera för att använda en anpassad e-postdomän för utgående e-post",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Du kan läsa mer här.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook-kommentarer",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Allow messages after conversation resolved",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Allow the end-users to send messages even after the conversation is resolved.",
      "WIDGET_STATUS_LABEL": "Widgetstatus",
      "WIDGET_STATUS_ENABLED": "Aktiverad",
      "WIDGET_STATUS_BUSINESS_HOURS": "Aktiverad under kontorstid",
      "WIDGET_STATUS_DISABLED": "Inaktiverad",
      "WIDGET_STATUS_HELP_TEXT": "Styr när widgeten visas för besökare på din webbplats",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "Språk för CSAT-undersökning och e-post",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Välj språket för alla e-postmeddelanden till kunder, inklusive CSAT-undersökningar, transkriberingar av konversationer och e-postaviseringar",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Ärv från kontot",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp-anslutning",
        "SUBTITLE": "Så här är inkorgen ansluten till WhatsApp.",
        "PROVIDER": "Leverantör",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Ansluten via Metas inbäddade registrering",
        "STATUS": "Status",
        "CONNECTED": "Ansluten",
        "RECONNECT_HINT": "Klicka på Anslut igen i meddelandet ovan.",
        "PHONE_NUMBER": "Telefonnummer",
        "BUSINESS_ACCOUNT": "WhatsApp Business-konto-ID",
        "OPEN_MANAGER": "Öppna i WhatsApp Manager",
        "PHONE_NUMBER_ID": "Telefonnummer-ID",
        "TEMPLATES": "Meddelandemallar",
        "TEMPLATES_COUNT": "{approved} av {total} godkända",
        "TEMPLATES_SYNCED": "Senast synkroniserad {date}",
        "TEMPLATES_NOT_SYNCED": "Inte synkroniserad än",
        "MANAGE_TEMPLATES": "Hantera mallar"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Please enter a value greater than 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limit the maximum number of conversations from this inbox that can be auto assigned to an agent"
    },
    "SLA": {
      "TITLE": "SLA-policyer",
      "SUB_TEXT": "Konfigurera SLA-tider för svar och lösning för varje prioritetsnivå för konversationer.",
      "LOADING": "Läser in SLA-policyer...",
      "FIELDS": {
        "ACTIVE": "Aktiv",
        "TICKET_PRIORITY": "Ärendets prioritet",
        "FIRST_RESPONSE_TIME": "Tid för första svar",
        "EVERY_RESPONSE_TIME": "Tid för varje svar",
        "RESOLUTION_TIME": "Lösningstid",
        "PLACEHOLDER": "t.ex. 1tim 30min"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA-policyerna har uppdaterats.",
        "ERROR_MESSAGE": "Det gick inte att uppdatera SLA-policyerna. Försök igen."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatisk prioritet",
      "SUB_TEXT": "Konfigurera automatisk tilldelning av prioritet baserat på konversationens innehåll.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Meddelande om fakturering",
        "MESSAGE": "Varje prioritetsbedömning debiteras. Se detaljerna för din plan för prisinformation."
      },
      "MODE": {
        "OFF": "Av",
        "ALL_MESSAGES": "På för alla inkommande meddelanden",
        "FIRST_MESSAGE": "På endast för det första inkommande meddelandet"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Konfiguration av prioritetsnivåer",
        "SUB_TEXT": "Konfigurera vilka prioritetsnivåer som ska aktiveras och deras beskrivningar. Ange tydliga kriterier så att AI kan avgöra när den här prioriteten ska tilldelas."
      },
      "DESCRIPTION_LABEL": "Beskrivning",
      "DESCRIPTION_PLACEHOLDER": "Beskriv konversationer som ska markeras med prioriteten {priority}",
      "SET_AS_DEFAULT": "Ange som standardprioritet",
      "MULTIPLE_DEFAULTS_WARNING": "Endast en prioritetsnivå ska anges som standard. Avmarkera övriga standardval."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatisk märkning",
      "SUB_TEXT": "Konfigurera automatisk tilldelning av etiketter baserat på konversationens innehåll.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Meddelande om fakturering",
        "MESSAGE": "Varje märkningsbedömning debiteras. Se detaljerna för din plan för prisinformation."
      },
      "MODE": {
        "OFF": "Av",
        "CONVERSATION_OPEN": "Vid konversationens öppning",
        "CONVERSATION_CLOSE": "Vid konversationens stängning",
        "ALL_MESSAGES": "Vid varje meddelande - oavsett status",
        "FIRST_MESSAGE": "Vid första meddelandet - oavsett status"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Konfiguration av etiketter",
        "SUB_TEXT": "Konfigurera vilka etiketter som ska vara tillgängliga för automatisk tilldelning och deras beskrivningar. Ange tydliga kriterier så att AI kan avgöra när den här etiketten ska användas."
      },
      "DESCRIPTION_LABEL": "Beskrivning",
      "DESCRIPTION_PLACEHOLDER": "Beskriv konversationer som ska märkas med {label}. Om du lämnar detta tomt används etikettens beskrivning.",
      "NO_LABELS_MESSAGE": "Inga etiketter hittades. Skapa etiketter först för att aktivera automatisk märkning.",
      "CREATE_LABELS_LINK": "Skapa etiketter"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Återauktorisera",
      "SUBTITLE": "Din Facebook-anslutning har löpt ut, vänligen återanslut din Facebook-sida för att fortsätta med tjänsterna",
      "MESSAGE_SUCCESS": "Återanslutning lyckades",
      "MESSAGE_ERROR": "Ett fel uppstod, vänligen försök igen"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Förchattformulär gör det möjligt för dig att samla in användarinformation innan de börjar samtala med dig.",
      "SET_FIELDS": "Pre chat form fields",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Fields",
        "LABEL": "Label",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Key",
        "TYPE": "Type",
        "REQUIRED": "Required"
      },
      "ENABLE": {
        "LABEL": "Aktivera formulär före chatt",
        "OPTIONS": {
          "ENABLED": "Ja",
          "DISABLED": "Nej"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "Detta meddelande skulle vara synligt för användarna tillsammans med formuläret"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Besökare bör uppge sitt namn och sin e-postadress innan de startar chatten"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Ställ in din tillgänglighet",
      "SUBTITLE": "Set your availability on your livechat widget",
      "WEEKLY_TITLE": "Set your weekly hours",
      "TIMEZONE_LABEL": "Select timezone",
      "UPDATE": "Update business hours settings",
      "TOGGLE_AVAILABILITY": "Enable business availability for this inbox",
      "UNAVAILABLE_MESSAGE_LABEL": "Unavailable message for visitors",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Enable availability for this day",
        "UNAVAILABLE": "Unavailable",
        "HOURS": "hours",
        "VALIDATION_ERROR": "Starting time should be before closing time.",
        "CHOOSE": "Choose"
      },
      "ALL_DAY": "All-Day",
      "SAVE_TO_ALL": "Spara i alla inkorgar",
      "SAVE_TO_ALL_TITLE": "Kopiera arbetstider",
      "SAVE_TO_ALL_CONFIRM": "Inställningarna från det här formuläret (tillgänglighetsomkopplare, frånvaromeddelande, tidszon och arbetstider) kopieras till alla andra inkorgar utom e-post- och telefoninkorgar. Är du säker på att du vill fortsätta?",
      "SAVE_TO_ALL_CANCEL": "Avbryt",
      "SAVE_TO_ALL_YES": "Ja, kopiera till alla",
      "SAVE_TO_ALL_SUCCESS": "Arbetstiderna har kopierats till alla andra inkorgar",
      "SAVE_TO_ALL_ERROR": "Det gick inte att kopiera arbetstiderna till andra inkorgar"
    },
    "PHONE": {
      "TITLE": "Telefoninställningar",
      "SUBTITLE": "Konfigurera vilka samtal som ska visas under den här inkorgen.",
      "UPDATE": "Spara inställningar",
      "EDIT": {
        "SUCCESS_MESSAGE": "Telefoninställningarna har uppdaterats"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefonnummer",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Set your IMAP details",
      "NOTE_TEXT": "To enable SMTP, please configure IMAP.",
      "UPDATE": "Update IMAP settings",
      "TOGGLE_AVAILABILITY": "Enable IMAP configuration for this inbox",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update IMAP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Logga in",
        "PLACE_HOLDER": "Logga in"
      },
      "PASSWORD": {
        "LABEL": "Lösenord",
        "PLACE_HOLDER": "Lösenord"
      },
      "ENABLE_SSL": "Enable SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Set your SMTP details",
      "UPDATE": "Update SMTP settings",
      "TOGGLE_AVAILABILITY": "Enable SMTP configuration for this inbox",
      "TOGGLE_HELP": "Enabling SMTP will help the user to send email",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update SMTP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Logga in",
        "PLACE_HOLDER": "Logga in"
      },
      "PASSWORD": {
        "LABEL": "Lösenord",
        "PLACE_HOLDER": "Lösenord"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Encryption",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Mode",
      "AUTH_MECHANISM": "Authentication"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "E-postleverans (DNS)",
      "SUB_TITLE": "Vi kontrollerar SPF-, DKIM-, DMARC- och MX-posterna för {domain} varje arbetsdag. När något gör att mottagande servrar avvisar era svar eller flyttar dem till skräppost får administratörer ett e-postmeddelande med lösningen.",
      "RUN": "Kör kontroll",
      "RUN_SUCCESS": "DNS-kontrollen är klar",
      "RUN_ERROR": "Det gick inte att köra DNS-kontrollen, försök igen",
      "NOT_CHECKED": "Inte kontrollerad ännu.",
      "CHECKED_AT": "Senast kontrollerad {time}.",
      "DNS_UNAVAILABLE": "Den senaste kontrollen fick inget svar från domänens namnservrar. Resultatet nedan kommer från kontrollen innan.",
      "SENDER": {
        "SMTP": "Svar skickas via {host}.",
        "PLATFORM": "Svar skickas via våra e-postservrar."
      },
      "STATUS": {
        "OK": "Alla poster är i ordning",
        "WARNING": "Vissa poster kan förbättras",
        "ERROR": "Svar kanske inte når mottagarna",
        "UNKNOWN": "Okänd"
      },
      "SEVERITY": {
        "ERROR": "Problem",
        "WARNING": "Varning"
      },
      "FIX": "Åtgärda det med den här DNS-posten:",
      "RECORD_TYPE": "Typ",
      "RECORD_HOST": "Namn",
      "RECORD_VALUE": "Värde",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF-post saknas",
          "DESCRIPTION": "Domänen anger inte vilka servrar som får skicka e-post för den. Många e-postservrar behandlar då era svar som skräppost. Lägg till en SPF-post som tillåter {sender}."
        },
        "spf_multiple": {
          "TITLE": "Domänen har {count} SPF-poster",
          "DESCRIPTION": "En domän får bara ha en SPF-post. Om det finns flera ignorerar mottagande servrar SPF och avvisar ofta e-posten. Slå ihop dem till en post."
        },
        "spf_not_authorized": {
          "TITLE": "SPF tillåter inte servern som skickar era svar",
          "DESCRIPTION": "Era svar skickas via {sender}, men domänens SPF-post listar den inte. Nuvarande post: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF-posten kräver för många DNS-uppslag",
          "DESCRIPTION": "Mottagande servrar slutar kontrollera SPF efter {limit} DNS-uppslag, men {sender}, som skickar era svar, nås först efter {lookups}. Era svar misslyckas med SPF. Flytta {sender} till början av posten och ta bort include-poster som domänen inte längre använder."
        },
        "spf_lookups_others": {
          "TITLE": "Vissa avsändare i SPF-posten ligger bortom uppslagsgränsen",
          "DESCRIPTION": "SPF-posten kräver {lookups} DNS-uppslag, mottagande servrar slutar efter {limit}. Era svar matchas i tid och klarar SPF, men e-post från de här avsändarna misslyckas med SPF: {senders}. Ta bort include-poster som domänen inte längre använder."
        },
        "spf_malformed": {
          "TITLE": "SPF-posten är trasig",
          "DESCRIPTION": "Mottagande servrar kan inte läsa domänens SPF-post, så den skyddar inte era svar. Problemet finns i: {terms}. Ersätt posten med den korrigerade."
        },
        "dkim_missing": {
          "TITLE": "DKIM-signatur är inte konfigurerad",
          "DESCRIPTION": "Vi hittade ingen DKIM-nyckel på {selectors}. Utan den signeras inte era svar och hamnar oftare i skräppost. Aktivera DKIM-signering för domänen hos er e-postleverantör."
        },
        "dmarc_missing": {
          "TITLE": "DMARC-post saknas",
          "DESCRIPTION": "Stora e-postleverantörer som Gmail och Microsoft förväntar sig en DMARC-post. Utan den hamnar era svar oftare i skräppost."
        },
        "dmarc_fails": {
          "TITLE": "DMARC instruerar mottagarna att avvisa era svar",
          "DESCRIPTION": "Domänens DMARC-policy är ”{policy}” och era svar klarar varken SPF eller DKIM, så mottagarna avvisar dem eller flyttar dem till skräppost. Åtgärda SPF och DKIM ovan."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blockerar svar som skickas via våra e-postservrar",
          "DESCRIPTION": "Den här inkorgen skickar svar via våra e-postservrar, men domänens DMARC-policy är ”{policy}”, så mottagarna avvisar dem eller flyttar dem till skräppost. Ställ in SMTP för er egen e-postserver för den här inkorgen."
        },
        "mx_missing": {
          "TITLE": "Domänen har ingen MX-post",
          "DESCRIPTION": "Utan en MX-post kan ingen skicka e-post till domänen, så kunderna kan inte svara på era meddelanden."
        }
      }
    },
    "NOTE": "Note: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "Ett fel uppstod, vänligen försök igen"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Website Name",
          "PLACE_HOLDER": "Ange namnet på din webbplats (t.ex. Acme Inc)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "Välkomstrubrik",
          "PLACE_HOLDER": "Hi there!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Välkomsttagline",
          "PLACE_HOLDER": "Vi gör det enkelt att ta kontakt med oss. Fråga oss något, eller dela din feedback."
        },
        "REPLY_TIME": {
          "LABEL": "Reply Time",
          "IN_A_FEW_MINUTES": "Inom några minuter",
          "IN_A_FEW_HOURS": "Inom några timmar",
          "IN_A_DAY": "Inom en dag"
        },
        "WIDGET_COLOR_LABEL": "Widgetfärg",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Bubble Position",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Maxhöjd för olästa meddelanden (px)",
          "PLACE_HOLDER": "Ingen gräns",
          "HELP_TEXT": "Begränsa den maximala höjden på popupen för olästa meddelanden i pixlar. Lämna tomt för standardbeteendet (ingen gräns)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Bubble Type",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chatta med oss",
          "LABEL": "Widget Bubble Launcher Title",
          "PLACE_HOLDER": "Chatta med oss"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Update Widget Settings",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Svarar vanligtvis inom några minuter",
        "IN_A_FEW_HOURS": "Svarar vanligtvis inom några timmar",
        "IN_A_DAY": "Svar vanligtvis inom en dag"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Starta konversation",
        "CHAT_INPUT_PLACEHOLDER": "Skriv ditt meddelande"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Vi är online",
          "OFFLINE": "Vi är borta för tillfället"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hello"
      },
      "BRANDING_TEXT": "Drivs av JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Hemsida",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "E-post",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API-kanal",
      "PHONE": "SIP-telefon",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
